/**
 * Control's embedding tools are switched off while DLI-1638 checks whether anyone still needs
 * them: Control DC (the candidates list and a candidate's detail), Embedding Details and the
 * Embeddings data table. Forge's Remote DC and Cleaning tool replace them. Their routes render
 * a notice that links to the replacement, and the links into them are hidden.
 *
 * The pages stay compiled and tested, so turning them back on is this flag and a frontend
 * release. Outs Correction and AI Audit share code with them and stay on.
 */
export const CONTROL_EMBEDDING_TOOLS_ENABLED: boolean = false;
